export const WEB_VITALS_INSTRUMENTATION_NAME = 'web_vitals';
export const WEB_VITALS_INSTRUMENTATION_VERSION = '1.0.0';
export const LONG_TASK_INSTRUMENTATION_VERSION = '1.0.0';
export const LONG_TASKS_INSTRUMENTATION_NAME = 'long_tasks';
export const RESOURCES_INSTRUMENTATION_NAME = 'resources';
export const RESOURCES_INSTRUMENTATION_VERSION = '1.0.0';
export const DOM_INSTRUMENTATION_NAME = 'dom';
export const DOM_INSTRUMENTATION_VERSION = '1.0.0';
export const CUSTOM_MEASUREMENT_INSTRUMENTATION_NAME = 'custom_measurement';
export const CUSTOM_MEASUREMENT_INSTRUMENTATION_VERSION = '1.0.0';
export const ALL_WEB_VITALS_METRICS = {
    lcp: true,
    fid: true,
    cls: true,
    fcp: true,
    inp: true,
    ttfb: true,
    tbt: true,
    lt: true,
};
export const LONGTASK_DURATION = 50;
export const INTERNAL_INSTRUMENTATION_NAME = 'internal';
export const FONTS_URL = 'fonts.googleapis.com';
export const CSS_EXTENSIONS = ['.css'];
export const OTHER_EXTENSIONS = ['.wasm', '.manifest'];
export const SCRIPT_EXTENSIONS = ['.js', '.mjs'];
export const MEDIA_EXTENSIONS = [
    '.mp3',
    '.mp4',
    '.wav',
    '.ogg',
    '.webm',
    '.avi',
];
export const DOC_EXTENSIONS = [
    '.pdf',
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx',
    '.csv',
    '.html',
];
export const FONT_EXTENSIONS = [
    '.woff',
    '.woff2',
    '.ttf',
    '.otf',
    '.eot',
];
export const IMG_EXTENSIONS = [
    '.svg',
    '.jpg',
    '.png',
    '.jpeg',
    '.bmp',
    '.webp',
];
